import { colors, darkColors, radius, spacing, toCssVariables } from '@i9portal/ui';

/**
 * Paleta categórica dos gráficos (3 primeiras posições da paleta de referência,
 * validadas para daltonismo em claro e escuro).
 */
const SERIES_LIGHT = { 'series-1': '#2a78d6', 'series-2': '#eb6834', 'series-3': '#1baf7a' };
const SERIES_DARK = { 'series-1': '#3987e5', 'series-2': '#d95926', 'series-3': '#199e70' };

function vars(entries: Record<string, string | number>, prefix: string, unit = ''): string {
  return Object.entries(entries)
    .map(([k, v]) => `--${prefix}${k}: ${v}${typeof v === 'number' ? unit : ''};`)
    .join('\n');
}

/** CSS com os design tokens de @i9portal/ui como CSS custom properties. */
export function buildThemeCss(): string {
  const shared = `${vars(spacing, 'space-', 'px')}\n${vars(radius, 'radius-', 'px')}`;
  return `:root {\n${toCssVariables(colors)}\n${vars(SERIES_LIGHT, '')}\n${shared}\ncolor-scheme: light dark;\n}
@media (prefers-color-scheme: dark) {\n:root {\n${toCssVariables(darkColors)}\n${vars(SERIES_DARK, '')}\n}\n}`;
}

/** Injeta as variáveis no <head> (uma única vez). */
export function injectThemeVariables(doc: Document = document): void {
  if (doc.getElementById('i9-theme-tokens')) return;
  const style = doc.createElement('style');
  style.id = 'i9-theme-tokens';
  style.textContent = buildThemeCss();
  doc.head.prepend(style);
}
